
<template>

	<mymodal ref="modal" title="Добавить оценочную подгруппу" ok="Добавить" :reset="reset" :check="check" :submit="submit">

		<b-form-group label="Наименование" label-for="name_input">

			<b-form-input id="name_input" v-model="name" required :formatter="first_letter"></b-form-input>
		
		</b-form-group>

		<!--
		<b-form-group label="Фильтр" label-for="filter_select">
			
			<v-select id="filter_select" v-model="filter" :options="filter_options" :reduce="obj => obj.id" label="name" appendToBody/>
		
		</b-form-group>
		-->

	</mymodal>

</template>

<script>

import api from "../../../api"
import main_tree from "../../../api/main_tree"
import mymodal from "../../widgets/modal"

export default
{
	props :
	{
		parent_id : String,
	},

	components :
	{
		mymodal,
	},

	data()
	{
		return {

			name : null,
			filter : null,

			filter_options : [],
		}
	},

	methods :
	{
		check()
		{
			return !!this.name
		},

		reset()
		{
			this.name = null
			this.filter = null

			api.call(this, "filters", "get_many", { query : { essence : "cadastral_objects" }, is_desc : false },
				response =>
				{
					this.filter_options = response.data.reverse()
				})
		},

		execute()
		{
			this.$refs.modal.execute()
		},

		submit()
		{
			var data =
			{
				parent : this.parent_id,
				name : this.name,
			}

			if(this.filter != null)
				data.filters = [ this.filter ]

			api.call(this, "cadastral_groups", "add", { data : data },
				() =>
					main_tree.create(this).then(() => this.$emit("need_refresh"))
				)
		},

		first_letter(value)
		{
			return value.charAt(0).toUpperCase() + value.slice(1)
		}
	}
}

</script>

